import React, { Component } from 'react'
import { Tabs, Empty } from 'hljd'
import { PreviewModal } from 'hlj-components'
import ChatInput from './ChatInput'
import CouponModal from './CouponModal'
import CashPackageModal from './cashPackageModal'
import { inject, observer } from 'mobx-react'
import Style from './style.module.less'
import {
  HOST_PAP,
  GROUP_PAP,
  USER_PAP,
  COUPON_FULL_REDUCTION,
  COUPON_UNLIMITED,
  FORBIDDEN_WORD,
  ALLOW_WORD,
  MSG_IMG_AND_TEXT,
  MSG_COUPON,
  MSG_CASH_PACKAGE
} from '../constant'

const TabPane = Tabs.TabPane

@inject('store')
@observer
export default class extends Component {
  componentWillUnmount() {
    this.props.chatStore.destroyTimer()
  }
  getChatItem = (list, type) => {
    const { chatDelMsg, forbiddenWords, prohibitUserIds } = this.props.chatStore

    if (!list || list.length == 0) {
      return (
        <div className={Style.empty}>
          <Empty />
        </div>
      )
    }

    return list.map(item => {
      const { id, msg_kind, time, user_info = {}, content } = item
      const { nick } = user_info
      const contentObj = JSON.parse(content || '{}')
      if (item.deleted) {
        return null
      }
      // msg_kind 1 文字、图片 2 语音 3  视频 4 红包 5 优惠券 6 商家 7 套餐/案例 8 婚品 15 宴会厅
      return (
        <div className={Style.item} key={id}>
          <div className={Style.user}>
            {/* <Avatar className={Style.avatar} src={avatar} /> */}
            <div>
              <p className={Style.name}>{nick}</p>
              <p className={Style.time}>{time}</p>
            </div>
          </div>
          {msg_kind == MSG_IMG_AND_TEXT &&
            !!contentObj.text && (
              <p className={Style.message}>{contentObj.text}</p>
            )}
          {msg_kind == MSG_IMG_AND_TEXT &&
            !!contentObj.medias && (
              <div className={Style.imgs}>
                {contentObj.medias.map((img = {}, index) => {
                  if (
                    img.media &&
                    img.media.photo &&
                    img.media.photo.image_path
                  ) {
                    return (
                      <img
                        key={index}
                        onClick={() =>
                          PreviewModal.open({
                            children: <img src={img.media.photo.image_path} />
                          })
                        }
                        src={`${
                          img.media.photo.image_path
                        }?imageView2/1/w/50/h/50`}
                      />
                    )
                  }
                  return null
                })}
              </div>
            )}
          {msg_kind == MSG_COUPON && (
            <div className={Style.coupon}>
              {contentObj.type == COUPON_FULL_REDUCTION && (
                <p className={Style['coupon-desc']}>
                  满￥{contentObj.money_sill}减￥{contentObj.value}
                </p>
              )}
              {contentObj.type == COUPON_UNLIMITED && (
                <p className={Style['coupon-desc']}>
                  现金券￥{contentObj.value}
                </p>
              )}
            </div>
          )}
          {msg_kind == MSG_CASH_PACKAGE && (
            <div className={Style['cash-package']}>
              <div className={Style['head']}>
                <p>{contentObj.group_name}</p>
                {/*<p>*/}
                {/*  <span>{contentObj.type}</span>*/}
                {/*  <span>¥{contentObj.value}</span>*/}
                {/*</p>*/}
              </div>
              {/*<p className={Style['foot']}>红包</p>*/}
            </div>
          )}
          {type == HOST_PAP && (
            <div className={Style.footer}>
              <span onClick={chatDelMsg(id)}>删除</span>
            </div>
          )}
          {type == GROUP_PAP && (
            <div className={Style.footer}>
              {prohibitUserIds.indexOf(user_info.id) > -1 ? (
                <span onClick={forbiddenWords(user_info.id, ALLOW_WORD)}>
                  取消禁言
                </span>
              ) : (
                <span onClick={forbiddenWords(user_info.id, FORBIDDEN_WORD)}>
                  禁言
                </span>
              )}
            </div>
          )}
          {type == USER_PAP && (
            <div className={Style.footer}>
              <span onClick={forbiddenWords(user_info.id, ALLOW_WORD)}>
                取消禁言
              </span>
            </div>
          )}
        </div>
      )
    })
  }
  render() {
    const {
      chatRoomList,
      liveList,
      prohibitUsers,
      setLiveListRef,
      setRoomListRef,
      onTabChange
    } = this.props.chatStore

    return (
      <div className={Style['tab-card']}>
        <Tabs defaultActiveKey="1" onChange={onTabChange}>
          <TabPane tab="主播说" key={HOST_PAP}>
            <div className={Style.list} ref={ref => setLiveListRef(ref)}>
              {this.getChatItem(liveList, HOST_PAP)}
            </div>
            <ChatInput />
            <CouponModal />
            <CashPackageModal />
          </TabPane>
          <TabPane tab="大家说" key={GROUP_PAP}>
            <div className={Style.list} ref={ref => setRoomListRef(ref)}>
              {this.getChatItem(chatRoomList, GROUP_PAP)}
            </div>
          </TabPane>
          <TabPane tab="禁言用户" key={USER_PAP}>
            <div className={Style.list}>
              {this.getChatItem(prohibitUsers, USER_PAP)}
            </div>
          </TabPane>
        </Tabs>
      </div>
    )
  }
}
